export const FORM_CREATOR = 'creator';
export const FORM_INITIATOR = 'initiator';
export const FORM_SUBMITTER = 'submitter';

export const FORM_ROLES = {
  FORM_CREATOR,
  FORM_INITIATOR,
  FORM_SUBMITTER,
};
